function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1939.356,234.835l4.879,4.879-4.879,4.879",
  transform: "translate(245.594 -1938.356) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.759,
    height: 6.879,
    viewBox: "0 0 11.759 6.879"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Arrow.5af176c2.svg";
export { SvgArrow as ReactComponent };